/** 应用名已经单独展示。标题若以应用名开头，去掉这段重复，只留版本和审核结果。 */
export function activityHeadline(title: string, appName: string): string {
  const name = appName.trim()
  const text = title.trim()
  if (!name || !text.startsWith(name) || text.length === name.length) return text
  const rest = text.slice(name.length).trim()
  return rest || text
}
